import React from "react";
import "./Links.css"; // Ensure to import the CSS file

const Links = () => {
  const headings = [
    {
      label: "Diploma Student Result - Andhra Pradesh State Board",
      link: "https://sbtet.ap.gov.in/APSBTET/results.do",
    },
    {
      label: "SBTET AP Official Portal for Students",
      link: "https://sbtet.ap.gov.in/APSBTET/",
    },
    {
      label: "APSBTET Student Portal for Exam Details",
      link: "https://apsbtet.net/studentportal/screens/mainstudentinfo.aspx",
    },
   
    {
      label: "Polycet",
      link: "https://appolycet.nic.in/",
    },
    {
      label: "State Board of Technical Education & Training AP",
      link: "https://apsbtet.ap.gov.in/",
    },
  ];

  return (
    <div className="overflow-hidden bg-[#2C9CB5] py-1 links">
      <div className="links-container stop-scroll-on-hover animate-scroll-left">
        {headings.map((item, index) => (
          <a
            key={index}
            href={item.link}
            target="_blank"
            rel="noopener noreferrer"
            className="link-item font-semibold text-animation hover:text-opacity-80 transition"
          >
            <span>{item.label} ||</span>
          </a>
        ))}
      </div>
    </div>
  );
};

export default Links;
